<template>
  <div v-if="value" class="alert-warning p-xs too-many-result-msg">
    <div class="panel-tools">
      <a class="closebox" @click="close"><i class="fa fa-times"></i></a>
    </div>

    <div v-if="isSimpleSearch === true">
      <div class="text-left" style="display: inline-block;">
        <h5>
          <i class="fa fa-exclamation-triangle fa-1x text-warning"></i>
          Too many results to rank experts. You may enter a more <b>specific</b> query or combine it with <b>suggestions</b>
        </h5>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-xs-12">
          <h3><i class="fa fa-exclamation-triangle fa-1x text-warning"></i> Too many results to rank experts. You may:</h3>
          <ul style="list-style: inside; margin-top: 15px;">
            <li>Enter a more <b>specific</b> query</li>
            <li>Combine the current query with <b>suggestions</b></li>
            <li>Use the <b>advanced search</b></li>
          </ul>
        </div>
        <div class="col-xs-12 text-center">
          <a href="https://academy.idexlab.com/hc/en-us/articles/360002852879-Query-advices" target="_blank" class="btn btn-info btn-sm">
            watch our tutorials
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
</style>
<script>
export default {

  components: {},
  name: 'TooManyResultNotificationBox',
  props: ['value', 'isSimpleSearch'],
  methods: {
    close: function (event) {
      event.preventDefault()
      $('.too-many-result-msg').remove()
      $('.expert-overlay').remove()
    }
  },
  filters: {},
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/TooManyResultNotificationBox.vue